import React from "react";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/Endpoint";
import AccessControl from "../../helpers/accessControl";
import SwitchButton from "../Reusable/SwitchButton";
import { useNavigate } from "react-router-dom";

const FiscalYear = (props: any) => {
  const navigate = useNavigate();
  const onRowClick = (row: any) => {
    navigate(`/branch/edit/${row.original.id}`);
  };
  console.log(props, "props");
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Code",
      accessorKey: "code",
      cell: NACell,
    },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Contact",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "primary_email",
      cell: NACell,
    },

    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`/edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_setting"]}
    //       />
    //     </>
    //   ),
    // },
  ];

  return (
    <DataTable
      url={APIS.BRANCH}
      queryKey={"branch"}
      columns={defaultColumns}
      // addNewPagePath={"/create"}
      tableName={"branches"}
      onRowClick={onRowClick}
    />
  );
};

export default FiscalYear;
